var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10780IconServiceBlobBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a9c62307-1cd0-400c-911b-17ec6a9110ce",
    x1: 9,
    y1: 15.834,
    x2: 9,
    y2: 5.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bedd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#32d4f5"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MsPortalFx.base.images-7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f31d214e-f09e-49e3-b3d2-7c5d55682d09"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.5,5.788h17a0,0,0,0,1,0,0v9.478a.568.568,0,0,1-.568.568H1.068A.568.568,0,0,1,.5,15.266V5.788A0,0,0,0,1,.5,5.788Z",
    fill: "url(#a9c62307-1cd0-400c-911b-17ec6a9110ce)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.071,2.166H16.929a.568.568,0,0,1,.568.568V5.788a0,0,0,0,1,0,0H.5a0,0,0,0,1,0,0V2.734A.568.568,0,0,1,1.071,2.166Z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.328,
    y: 7.049,
    width: 6.281,
    height: 3.408,
    rx: 0.283,
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.336,
    y: 7.049,
    width: 6.281,
    height: 3.408,
    rx: 0.283,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.296,
    y: 11.128,
    width: 6.281,
    height: 3.408,
    rx: 0.283,
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.304,
    y: 11.128,
    width: 6.281,
    height: 3.408,
    rx: 0.283,
    fill: "#0078d4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10780IconServiceBlobBlock);
export default __webpack_public_path__ + "static/media/10780-icon-service-Blob-Block.31a5e209a71aee8bf3ac09948db8ef8b.svg";
export { ForwardRef as ReactComponent };